"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = removeArticleFromText;
var _constants = require("@seedlang/constants");
var _lodash = require("lodash");
function removeArticleFromText(text, languageId) {
  if (!text || typeof text !== 'string') return text;
  if (!languageId) return text;
  var singularArticles = _constants.Constants.SINGULAR_ARTICLES[languageId];
  var pluralArticles = _constants.Constants.PLURAL_ARTICLES[languageId];
  var allArticles = (0, _lodash.uniq)((0, _lodash.flatten)([singularArticles ? (0, _lodash.values)(singularArticles) : [], pluralArticles ? (0, _lodash.values)(pluralArticles) : []])).filter(function (article) {
    return article && article.length > 0;
  });
  if (allArticles.length === 0) return text;
  var articlePattern = allArticles.map(function (article) {
    return article.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }).join('|');
  var regex = new RegExp("^(".concat(articlePattern, ")\\s+"), 'i');
  return text.replace(regex, '');
}